import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=2ba8fccf&"
import script from "./autocomplete.vue?vue&type=script&lang=js&"
export * from "./autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports